export default "__VITE_ASSET__Cyzjdej7__"